import { render, staticRenderFns } from "./TemplateDetailCards.vue?vue&type=template&id=c3c8211c&scoped=true"
import script from "./TemplateDetailCards.vue?vue&type=script&lang=js"
export * from "./TemplateDetailCards.vue?vue&type=script&lang=js"
import style0 from "./TemplateDetailCards.vue?vue&type=style&index=0&id=c3c8211c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3c8211c",
  null
  
)

export default component.exports